module.exports = __webpack_public_path__ + "static/img/computer.aeadd8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/computer.png
// module id = /atU
// module chunks = 1